module.exports = __webpack_public_path__ + "img/people-image-sample.d1d963dd.png";